import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxRadioButtonComponent } from './wdx-radio-button.component';
import { WdxButtonModule } from '@wdx/shared/components/wdx-button';

@NgModule({
    imports: [CommonModule, WdxIconModule, WdxButtonModule],
    declarations: [WdxRadioButtonComponent],
    exports: [WdxRadioButtonComponent],
})
export class WdxRadioButtonModule {}
